export default __webpack_public_path__ + "static/media/trading-alerts-tradingAlerts-dark.330f5d25.png";